import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('client', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 C0.44772,0 0,0.44772 0,1 L0,13 C0,13.5523 0.44772,14 1,14 L17,14 C17.5523,14 18,13.5523 18,13 L18,1 C18,0.44772 17.5523,0 17,0 L1,0 Z M1.5,1 C1.22386,1 1,1.22386 1,1.5 L1,12.5 C1,12.7761 1.22386,13 1.5,13 L16.5,13 C16.7761,13 17,12.7761 17,12.5 L17,1.5 C17,1.22386 16.7761,1 16.5,1 L1.5,1 Z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,15.5 C3,15.2239 3.22386,15 3.5,15 L14.5,15 C14.7761,15 15,15.2239 15,15.5 C15,15.7761 14.7761,16 14.5,16 L3.5,16 C3.22386,16 3,15.7761 3,15.5 Z",
    fill: props.colors[0],
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: props.colors[0],
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4 10 7 6 10 9 14 3.5"
  })))));
});